import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useEditQuestion = ({
  id,
  questionId,
}: {
  id: string;
  questionId?: string;
}) => {
  const queryClient = useQueryClient();
  const router = useRouter();
  const trpc = useTRPC();
  return useMutation(
    trpc.questions.update.mutationOptions({
      onSuccess: () => {
        toast.success("Question edited successfully");
        queryClient.invalidateQueries({
          queryKey: trpc.questions.getWithFileNames.queryKey({ id }),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.questions.getWithOptions.queryKey({ id }),
        });
        router.refresh();
      },
      onError: (error, _variables, _context) => {
        console.error("Failed to edit question", error);
        toast.error(error.message);
      },
    }),
  );
};
